import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { UI_VERSION, IS_CLIENT, HOSTNAME, SOCIAL_METHODS, POP_SOCIAL_AUTH_METHOD } from '@constants';
import { Loader } from '@components/Loader';
import { MainHead } from './Main-Head';
import { ui } from './ui';

export const SocialLayout = ({ title, mode, children }) => {
  const { locale } = useRouter();

  useEffect(() => {
    if (IS_CLIENT) {
      const script = document.createElement('script');

      script.src = `https://ui.${HOSTNAME}/static/js/site.js?v${UI_VERSION}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      script.onload = () => {
        const url = new URL(window.location.href);
        let method = url.searchParams.get('method');

        if (method) {
          localStorage.setItem(POP_SOCIAL_AUTH_METHOD, method);
        } else {
          method = localStorage.getItem(POP_SOCIAL_AUTH_METHOD);
        }

        ui.connectTranslations();
        ui.initFormEntry({ locale });

        if (mode === SOCIAL_METHODS.google) {
          ui.getGoogleCode({ method });
        } else if (mode === SOCIAL_METHODS.facebook) {
          ui.getFacebookCode({ method });
        } else if (mode === SOCIAL_METHODS.vk) {
          ui.getVkCode({ method });
        }
      };
    }
  }, []);

  return (
    <>
      <MainHead title={title} />
      <main>{children}</main>
      <Loader />
    </>
  );
};
